<template>
  <v-container>
    <h1>Добро пожаловать на защищенную страницу!</h1>
    <h4>Miner ID: {{ userEmail }}</h4>
    <p>Только авторизованные пользователи могут видеть этот контент.</p>

    <!-- Кнопка выхода -->
    <v-btn @click="logoutUser" color="error">
      Выйти
    </v-btn>
  </v-container>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

// Получаем email пользователя из Vuex store
const userEmail = computed(() => store.getters.userEmail);

// Функция выхода пользователя
const logoutUser = async () => {
  try {
    await store.dispatch('logout');
    router.push('/login'); // Перенаправляем на страницу входа после выхода
  } catch (error) {
    console.error('Error during logout:', error.response ? error.response.data : error.message);
  }
};
</script>

  